import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './core/guards/auth/auth.guard';
import { SecureContainerComponent } from './secure/secure-container/secure-container.component';

export const inheritanceRoutes: Routes = [
  {
    path: 'inheritance',
    children: [
      {
        path: 'overview', // setting us up to change on public site
        loadChildren: () =>
          import('./public/inheritance-overview/inheritance-overview.module').then(
            (m) => m.InheritanceOverviewModule,
          ),
      },
      {
        path: 'triage',
        loadChildren: () => import('./public/triage/triage.module').then((m) => m.TriageModule),
      },
      {
        path: 'trust-triage',
        loadChildren: () =>
          import('./public/trust-triage/trust-triage.module').then((m) => m.TrustTriageModule),
      },
      {
        path: 'summary',
        loadChildren: () =>
          import('./public/triage-summary/triage-summary.module').then(
            (m) => m.TriageSummaryModule,
          ),
      },
    ],
  },
  {
    path: 'secure/inheritance',
    canActivate: [AuthGuard],
    component: SecureContainerComponent,
    children: [
      // inheritance secure pages
      {
        path: 'decedent-info',
        loadChildren: () =>
          import('./secure/decedent-info/decedent-info.module').then((m) => m.DecedentInfoModule),
      },
      {
        path: 'upload',
        loadChildren: () =>
          import('./secure/document-upload/document-upload.module').then(
            (m) => m.DocumentUploadModule,
          ),
      },
      {
        path: 'assume',
        loadChildren: () =>
          import('./secure/assume-inherit/assume-inherit.module').then(
            (m) => m.AssumeInheritModule,
          ),
      },
      {
        path: '',
        loadChildren: () =>
          import('./secure/selected-accounts/selected-accounts.module').then(
            (m) => m.SelectedAccountsModule,
          ),
      },
      {
        path: 'beneficiaries',
        loadChildren: () =>
          import('./secure/beneficiaries/beneficiaries.module').then((m) => m.BeneficiariesModule),
      },
      {
        path: 'estate',
        loadChildren: () => import('./secure/estate/estate.module').then((m) => m.EstateModule),
      },
      {
        path: 'personal-info',
        loadChildren: () =>
          import('./secure/personal-info/personal-info.module').then((m) => m.PersonalInfoModule),
      },
      {
        path: 'contact-info',
        loadChildren: () =>
          import('./secure/contact-info/contact-info.module').then((m) => m.ContactInfoModule),
      },
      {
        path: 'employment',
        loadChildren: () =>
          import('./secure/employment/employment.module').then((m) => m.EmploymentModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('./secure/client-due-diligence/client-due-diligence.module').then(
            (m) => m.ClientDueDiligenceModule,
          ),
      },
      {
        path: 'terms',
        loadChildren: () => import('./secure/terms/terms.module').then((m) => m.TermsModule),
      },
      {
        path: 'trust-info',
        loadChildren: () =>
          import('./secure/trust-info/trust-info.module').then((m) => m.TrustInfoModule),
      },
      {
        path: 'trust-tax-info',
        loadChildren: () =>
          import('./secure/trust-tax-info/trust-tax-info.module').then((m) => m.TrustTaxInfoModule),
      },
      {
        path: 'tcf-info-trust',
        loadChildren: () =>
          import('./secure/trust-to-trust-info/trust-to-trust-info.module').then(
            (m) => m.TrustToTrustInfoModule,
          ),
      },
      {
        path: 'tcf-sign-trust',
        loadChildren: () =>
          import('./secure/tcf-trust-sign/tcf-trust-sign.module').then((m) => m.TCFTrustSignModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(inheritanceRoutes)],
  exports: [RouterModule],
})
export class InheritanceRoutingModule {}
